export const BUSINESS_STAGES = [
  'Idea',
  'Start-Up',
  'Commercialisation',
  'Accelerated Growth',
  'Unicorn',
];

export const BUSINESS_STAGE_COLORS = {
  Idea: { bg: 'bg-sky-50', text: 'text-sky-700', ring: 'ring-sky-200' },
  'Start-Up': { bg: 'bg-blue-50', text: 'text-blue-700', ring: 'ring-blue-200' },
  Commercialisation: { bg: 'bg-indigo-50', text: 'text-indigo-700', ring: 'ring-indigo-200' },
  'Accelerated Growth': { bg: 'bg-orange-50', text: 'text-orange-700', ring: 'ring-orange-200' },
  Unicorn: { bg: 'bg-emerald-50', text: 'text-emerald-700', ring: 'ring-emerald-200' },
};

export function normalizeBusinessStage(input) {
  if (!input) return '';
  const v = String(input).toLowerCase();
  if (v.includes('stage 1') || v.trim() === '1') return 'Idea';
  if (v.includes('stage 2') || v.trim() === '2') return 'Start-Up';
  if (v.includes('stage 3') || v.trim() === '3') return 'Commercialisation';
  if (v.includes('stage 4') || v.trim() === '4') return 'Accelerated Growth';
  if (v.includes('stage 5') || v.trim() === '5') return 'Unicorn';
  if (v.includes('idea')) return 'Idea';
  if (v.includes('start')) return 'Start-Up';
  if (v.includes('commercial')) return 'Commercialisation';
  if (v.includes('accelerat') || v.includes('growth')) return 'Accelerated Growth';
  if (v.includes('unicorn')) return 'Unicorn';
  return input;
}
